import { UF } from './uf.class';
import { Price } from '../../shared/price-selection/model/price.class';
import { Municipio } from './municipio.class';
import { Atividade } from './atividade.class';
import { Item } from '../../shared/listbox/model/item.class';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

export class Cadastro {
    pessoal_hash         : string = '';
    pessoal_nmCliente    : string = '';
    pessoal_cdDocumento  : string = '1';
    pessoal_nuDocumento  : string = '';
    pessoal_dsOcupacao   : string = '';
    pessoal_dsOrganizacao: string = '';
    pessoal_dsCEP        : string = '';
    pessoal_dsEndereco   : string = '';
    pessoal_dsNumero     : string = '';
    pessoal_dsComplemento: string = '';
    pessoal_dsBairro     : string = '';
    pessoal_dsMunicipio  : string = '';
    pessoal_dsEstado     : string = '';
    pessoal_nuTelefone   : string = '';
    pessoal_dsEmail      : string = '';
    pessoal_cdSenha      : string = '';
    pessoal_icTermo      : boolean = false;

    produto_selecionado: number[] = [];
    alteracao_produto1_municipioTodos: Subject<string> = new Subject();
    alteracao_produto1_tipoPesquisa: Subject<string> = new Subject();
    alteracao_produto1_item: Subject<Item[]> = new Subject();
    alteracao_produto1_precoSelecionado: Subject<Price> = new Subject();
    alteracao_produto2_ufTodos: Subject<string> = new Subject();
    alteracao_produto2_uf: Subject<UF[]> = new Subject();
    alteracao_produto2_atividadeTodos: Subject<string> = new Subject();
    alteracao_produto2_negociacaoPersonalizada: Subject<boolean> = new Subject();
    alteracao_produto2_tipoNegociacao: Subject<string> = new Subject();
    alteracao_produto2_atividade: Subject<Atividade[]> = new Subject();

    _produto1_municipioTodos: string = '1';
    _produto1_itensSelecionados: Item[] = [];
    _produto1_precoSelecionado: Price = null;
    _produto1_tipoPesquisa: string = '1';
    
    produto2_cdUf: number = null;
    produto2_idAtividade: number = null;
    _produto2_ufTodos: string = '1';
    _produto2_ufSelecionados: UF[] = [];
    _produto2_atividadeTodos: string = '1';
    _produto2_negociacaoPersonalizada: boolean = false;
    _produto2_atividadeSelecionados: Atividade[] = [];
    _produto2_idVigencia: number = 3;
    _produto2_valor: number = 0;
    _produto2_tipoNegociacao: string = "2"; // Completa como padrão


    public get produto1_municipioTodos(): string {
        return this._produto1_municipioTodos;
    }
    public set produto1_municipioTodos(v: string) {
        this._produto1_municipioTodos = v;
        this.alteracao_produto1_municipioTodos.next(v);
    }
    public get produto1_itensSelecionandos(): Item[] {
        return this._produto1_itensSelecionados;
    }
    public set produto1_municipioSelecionados(v: Item[]) {
        this._produto1_itensSelecionados = v;
        this.alteracao_produto1_item.next(v);
    }
    public get produto1_precoSelecionado(): Price {
        return this._produto1_precoSelecionado;
    }
    public set produto1_precoSelecionado(v: Price) {
        this._produto1_precoSelecionado = v;
        this.alteracao_produto1_precoSelecionado.next(v);
    }
    public get produto1_tipoPesquisa(): string {
        return this._produto1_tipoPesquisa;
    }
    public set produto1_tipoPesquisa(v: string) {
        this._produto1_tipoPesquisa = v;
        this.alteracao_produto1_tipoPesquisa.next(v);
    }

    public get produto2_ufTodos(): string {
        return this._produto2_ufTodos;
    }
    public set produto2_ufTodos(v: string) {
        this._produto2_ufTodos = v;
        this.alteracao_produto2_ufTodos.next(v);
    }
    public get produto2_ufSelecionados(): UF[] {
        return this._produto2_ufSelecionados;
    }
    public set produto2_ufSelecionados(v: UF[]) {
        this._produto2_ufSelecionados = v;
        this.alteracao_produto2_uf.next(v);
    }
    public get produto2_atividadeTodos(): string {
        return this._produto2_atividadeTodos;
    }
    public get produto2_negociacaoPersonalizada(): boolean {
        return this._produto2_negociacaoPersonalizada;
    }
    public set produto2_atividadeTodos(v: string) {
        this._produto2_atividadeTodos = v;
        this.alteracao_produto2_atividadeTodos.next(v);
    }
    public set produto2_negociacaoPersonalizada(v: boolean) {
        this._produto2_negociacaoPersonalizada = v;
        this.alteracao_produto2_negociacaoPersonalizada.next(v);
    }
    public get produto2_atividadeSelecionados(): Atividade[] {
        return this._produto2_atividadeSelecionados;
    }
    public set produto2_atividadeSelecionados(v: Atividade[]) {
        this._produto2_atividadeSelecionados = v;
        this.alteracao_produto2_atividade.next(v);
    }

    public get produto2_tipoNegociacao(): string {
        return this._produto2_tipoNegociacao;
    }
    public set produto2_tipoNegociacao(v: string) {
        this._produto2_tipoNegociacao = v;
        this.alteracao_produto2_tipoNegociacao.next(v);
    }
}
